// extracted by mini-css-extract-plugin
export var cancelButton = "_l9-5";
export var content = "_l9-3";
export var createButton = "_l9-6";
export var drawerContainer = "_l9-0";
export var footer = "_l9-2";
export var header = "_l9-1";
export var orderFormColumn = "_l9-4";